import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectPeriod {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectPeriod = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectPeriod) => {
  const itemListFetch = useStoreActions((state) => state.student.fetchStudentAttendanceAllPeriod);
  const itemList = useStoreState((state) => state.student.studentAttendanceAllPeriodList);

  if (itemList == null) {
    itemListFetch();
  }
  
  const onSelect = (id) => {
    if (itemList) {
      const value = itemList.find((item) => item.id === id);
      onChange(value.id);
    }
  };

 

  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      className="periodSelect"
      // allowClear
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      placeholder="Select Period"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.id} value={type.id}>
            {type.name}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Period</Option>
      )}
    </Select>
  );
};
